export default {
    common: {
        title: "Rediger bilde",
        cancel: "Avbryt",
        save: "Lagre",
        crop: "Avling",
        adjustments: "Justeringer",
        filters: "Filtre",
        frames: "Rammer",
        overlays: "Overleggelser",
        text: "Tekst",
        stickers: "Klistremerker",
        brush: "Børste",
        ai: "Lag et bilde ved hjelp av kunstig intelligens",
        reset: "Nullstill",
        comingSoon: 'Kommer snart...',
    },
};
